<template>
    <div>
        <grid-layout
            v-show="_.get(dashboard, 'dashboardView') === 'totals'"
            :layout.sync="cards"
            :col-num="24"
            :row-height="25"
            :is-draggable="true"
            :is-resizable="true"
            :is-mirrored="false"
            :vertical-compact="true"
            :margin="[10, 10]"
            :use-css-transforms="true"
        >
            <grid-item
                v-for="card in cards"
                :x.sync="card.x"
                :y.sync="card.y"
                :w.sync="card.w"
                :h.sync="card.h"
                :i="card.i"
                :key="card.i"
                v-if="checkWidgets(card.parentId)"
            >
                <component
                    :is="card.component"
                    :ref="card.ref"
                    v-bind="card.props"
                    v-bind:appearance="appearance"
                    v-bind:tenant-id="tenantId"
                    v-bind:dashboard-id="_.get(dashboard, 'id', _.get(dashboard, 'dashboardId'))"
                    :class="appearance === 'black' ? 'component-white' : 'component-black'"
                >
                </component>
            </grid-item>
        </grid-layout>
    </div>
</template>

<script>
import AverageIncomeCard from "../card-totals/AverageIncomeCard";
import SettledCard from "../card-totals/SetteledCard";
import BrokerIncomeCard from "../card-totals/BrokerIncomeCard";
import BrokerNafCard from "../card-totals/BrokerNafCard";
import BrokerSettledCard from "../card-totals/BrokerSettledCard";
import closedApplicationCard from "../card-totals/ClosedApplicationCard";
import LenderIncomeCard from "../card-totals/LenderIncomeCard";
import LenderNafCard from "../card-totals/LenderNafCard";
import LenderSettledCard from "../card-totals/LenderSettledCard";
import SubmissionsCard from "../card-totals/SubmissionsCard";
import TeamIncomeCard from "../card-totals/TeamIncomeCard";
import TeamNafCard from "../card-totals/TeamNafCard";
import TeamSettledCard from "../card-totals/TeamSettledCard";
import TotalIncomeCard from "../card-totals/TotalIncomeCard";

export default {
    name: 'DashboardTotals',
    components: {
        "average-income-card": AverageIncomeCard,
        "settled-card": SettledCard,
        "broker-income-card": BrokerIncomeCard,
        "broker-naf-card": BrokerNafCard,
        "broker-settled-card": BrokerSettledCard,
        "closed-application-card": closedApplicationCard,
        "lender-income-card": LenderIncomeCard,
        "lender-naf-card": LenderNafCard,
        "lender-settled-card": LenderSettledCard,
        "submissions-card": SubmissionsCard,
        "team-income-card": TeamIncomeCard,
        "team-naf-card": TeamNafCard,
        "team-settled-card": TeamSettledCard,
        "total-income-card": TotalIncomeCard,
    },
    props: [
        'appearance',
        'tenantId',
        'dashboardId',
        'dashboard',
        'cards',
        'selectedWidgets'
    ],
    data() {
        return {}
    },
    watch: {},
    created() {
    },
    beforeDestroy() {
    },
    mounted() {
    },
    methods: {
        checkWidgets(id) {
            let getWidgetIds = this.selectedWidgets.filter(function (elem) {
                if (_.get(elem, 'id') == id) return elem
            })

            return this.selectedWidgets && this.selectedWidgets.length > 0 ? _.map(getWidgetIds, function getId(w) {
                return w.id
            }).toString() : id
        }
    }
}
</script>
